<template lang="pug">
.page-home-videos.py-10.secondary(v-if="items.length")
  v-container.d-flex.justify-center 
    v-sheet.transparent(max-width="720px", width="100%")
      .page-home-videos-carousel
        owl-carousel(
          ref="carousel",
          :items="1",
          :margin="xs ? 10 : 40",
          :auto-width="xs",
          :center="xs"
        )
          div(
            v-for="({ link }, i) in items",
            :key="i",
            :style="{ width: xs ? '300px' : '720px' }"
          )
            video-embed-card(:link="link")
        v-btn.page-home-videos-carousel-prev(@click="prev()", icon) 
          v-icon(color="primary darken-2") fas fa-chevron-left
        v-btn.page-home-videos-carousel-next(
          @click="next()",
          color="primary darken-2",
          icon
        ) 
          v-icon(color="primary darken-2") fas fa-chevron-right
</template>

<script>
import VideoEmbedCard from "../../cards/VideoEmbed.vue";

const _config = {
  mod: "videos",
};

export default {
  computed: {
    items() {
      return this.$rest(_config.mod).list;
    },
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    prev() {
      this.$refs.carousel.$el.querySelector(".owl-prev").click();
    },
    next() {
      this.$refs.carousel.$el.querySelector(".owl-next").click();
    },
  },
  beforeCreate() {
    this.$rest(_config.mod).get();
  },
  components: {
    VideoEmbedCard,
  },
};
</script>

<style>
.page-home-videos {
  background-image: url(/img/videos-bg.png);
  background-position: bottom;
  background-size: 100%;
  padding: 112px 0;
}

.page-home-videos-carousel .owl-nav {
  display: none;
}
.page-home-videos-carousel {
  position: relative;
}

.page-home-videos-carousel-prev,
.page-home-videos-carousel-next {
  position: absolute;
  top: calc(347px / 2);
  z-index: 99;
}

.page-home-videos-carousel-prev {
  left: -54px;
}

.page-home-videos-carousel-next {
  right: -54px;
}

@media screen and (max-width: 960px) {
  .page-home-videos-carousel-prev,
  .page-home-videos-carousel-next {
    top: initial;
    bottom: 0;
  }

  .page-home-videos-carousel-prev {
    left: 0;
  }
  .page-home-videos-carousel-next {
    right: 0;
  }
}

.owl-dots {
  margin-top: 12px;
}
.owl-dot span {
  background: #ccc !important;
}
.owl-dot.active span {
  background: var(--v-accent-base) !important;
}
</style>